import { data } from '@/routes/MeetingSign/mock/meetingList';
import { query } from 'src/utils/request';

// =============预算项目==================================
// 获取预算项目列表
export const getBudgetProjectList = async params => {
  return query('/zlb/budget/ep/project/page', {
    params,
  });
};
// 预算项目详情
export const getBudgetProjectDetail = async params => {
  return query('/zlb/budget/ep/project/detail', {
    params,
  });
};

// 新增项目
export const addBudgetProject = async data => {
  return query('/zlb/budget/ep/project/add', {
    method: 'post',
    data,
  });
};
// 编辑项目
export const editBudgetProject = async data => {
  return query('/zlb/budget/ep/project/update', {
    method: 'post',
    data,
  });
};
// 删除项目
export const deleteBudgetProject = async data => {
  return query('/zlb/budget/ep/project/delete', {
    method: 'post',
    data,
  });
};
// 获取预算项目类型列表
export const getBudgetProjectTypeList = async params => {
  return query('/zlb/budget/ep/project/type/list', {
    params,
  });
};
// 获取预算项目类型下拉列表
export const getBudgetProjectTypeDownList = async params => {
  return query('/zlb/budget/ep/project/type/down/tree', {
    params,
  });
};
// 预算项目类型详情
export const getBudgetProjectTypeDetail = async params => {
  return query('/zlb/budget/ep/project/type/detail', {
    params,
  });
};

// 新增项目类型
export const addBudgetProjectType = async data => {
  return query('/zlb/budget/ep/project/type/add', {
    method: 'post',
    data,
  });
};
// 编辑项目
export const editBudgetProjectType = async data => {
  return query('/zlb/budget/ep/project/type/update', {
    method: 'post',
    data,
  });
};
// 删除项目类型
export const deleteBudgetProjectType = async data => {
  return query('/zlb/budget/ep/project/type/delete', {
    method: 'post',
    data,
  });
};
// 项目导入-submit
export const submitProjectImport = async data => {
  return query('/zlb/budget/ep/project/import/submit', {
    method: 'post',
    data,
  });
};
// 项目导入-result
export const handleProjectImportResult = async params => {
  return query('/zlb/budget/ep/project/import/result', {
    params,
  });
};
// 项目导入-模板下载
export const getProjectImportTemplate = async params => {
  return query('/zlb/budget/ep/project/import/template', {
    params,
  });
};
// 项目库管理是否可以开启
export const getProjectLibrarySwitchOpenable = async params => {
  return query('/zlb/budget/ep/project/library/switch-openable', {
    params,
  });
};
// 项目库开启状态
export const getProjectLibrarySwitchStatus = async params => {
  return query('/zlb/budget/ep/project/library/switch-status', {
    params,
  });
};

// 项目库管理开关开启
export const enableProjectLibrary = async data => {
  return query('/zlb/budget/ep/project/library/switch-open', {
    method: 'post',
    data,
  });
};
// 关联财政项目
export const relateProjectFinance = async data => {
  return query('/zlb/budget/ep/project/finance/relation', {
    method: 'post',
    data,
  });
};
// 绑定虚拟团队与项目
export const projectBindVirtualTeam = async data => {
  return query('/zlb/budget/ep/project/bind-virtual-team', {
    method: 'post',
    data,
  });
};
// 年度预算管理-限制人员保存
export const savelBudgetLimitPerson = async data => {
  return query('/zlb/budget/ep/fill/record/limit-person/save', {
    data,
    method: 'post',
  });
};

// =============预算科目==================================
// 获取预算科目列表
export const getBudgetSubjectList = async params => {
  return query('/zlb/budget/ep/subject/list', {
    params,
  });
};
// 预算科目下拉框
export const getBudgetSubjectDownList = async params => {
  return query('/zlb/budget/ep/subject/down/list', {
    params,
  });
};
// 新增科目
export const addBudgetSubject = async data => {
  return query('/zlb/budget/ep/subject/add', {
    method: 'post',
    data,
  });
};
// 编辑科目
export const editBudgetSubject = async data => {
  return query('/zlb/budget/ep/subject/update', {
    method: 'post',
    data,
  });
};
// 删除科目
export const deleteBudgetSubject = async uk => {
  return query(`/zlb/budget/ep/subject/delete/${uk}`, {
    method: 'post',
  });
};
// 科目类型列表
export const getBudgetSubjectTypeList = async params => {
  return query('/zlb/budget/ep/subject/type/list', {
    params,
  });
};
// 科目类型_下拉框
export const getBudgetSubjectTypeDownList = async params => {
  return query('/zlb/budget/ep/subject/type/down/list', {
    params,
  });
};
// 科目类型_删除
export const deleteBudgetSubjectType = async code => {
  return query(`/zlb/budget/ep/subject/type/delete/${code}`, {
    method: 'post',
  });
};
// 新增科目类型
export const addBudgetSubjectType = async data => {
  return query('/zlb/budget/ep/subject/type/add', {
    method: 'post',
    data,
  });
};
// 编辑科目类型
export const editBudgetSubjectType = async data => {
  return query('/zlb/budget/ep/subject/type/update', {
    method: 'post',
    data,
  });
};

// 预算科目详情
export const getBudgetSubjectDetail = async params => {
  return query('/zlb/budget/ep/subject/detail', {
    method: 'get',
    params,
  });
};

// 获取预算部门列表
export const getBudgetDepList = async params => {
  return query('/zlb/budget/ep/dep/list', { params });
};
// 获当前人员所属部门列表
export const getUserCurrentDepList = async () => {
  return query('/zlb/api/mbp/baida/business/general-form/find-departments', {
    method: 'POST',
    data,
  });
};
// 获取预算人员列表
export const getBudgetUserList = async params => {
  return query('/zlb/budget/ep/user/list', {
    params,
  });
};
// 反结转
export const unTransferSubject = async data => {
  return query('/zlb/budget/ep/subject/un-transfer', {
    method: 'post',
    data,
  });
};
// 批量查询已结转科目编码
export const getcarryOverSubject = async data => {
  return query('/zlb/budget/ep/subject/transfer/list', {
    method: 'post',
    data,
  });
};
// 结转科目
export const carryOverSubject = async data => {
  return query('/zlb/budget/ep/subject/batch-transfer', {
    method: 'post',
    data,
  });
};
// 结转科目设置-设置
export const carryOverSubjectSettings = async data => {
  return query('/zlb/budget/ep/subject/settings/subject-transfer', {
    method: 'post',
    data,
  });
};
// 结转科目设置-详情
export const carryOverSubjectSettingsInfo = async params => {
  return query('/zlb/budget/ep/subject/settings/subject-transfer', {
    method: 'GET',
    params,
  });
};

// =============预算填报模板==================================
// 获取预算填报模板
export const getBudgetTemplateList = async params => {
  return query('/zlb/budget/ep/fill/template/list', {
    params,
  });
};
// 获取预算填报模板
export const getBudgetTemplatePreview = async params => {
  return query('/zlb/budget/ep/fill/template/preview', {
    params,
  });
};
// 保存预算填报模板
export const saveBudgetTemplate = async data => {
  return query('/zlb/budget/ep/fill/template/save-or-update', {
    data,
    method: 'POST',
  });
};
// 下发预算填报模板
export const publishBudgetTemplate = async data => {
  return query('/zlb/budget/ep/fill/template/publish', {
    data,
    method: 'POST',
  });
};
// 撤回预算填报模板
export const cancelBudgetTemplate = async data => {
  return query('/zlb/budget/ep/fill/template/cancel', {
    data,
    method: 'POST',
  });
};

// 查询部门的默认项目
export const getDeptDefaultProject = async data => {
  return query('/zlb/budget/ep/project/list-by-dep', {
    data,
    method: 'POST',
  });
};

// 查询科目下拉（收入、支出）
export const getBudgetSubjectDownListV2 = async params => {
  return query('/zlb/budget/ep/subject/list', {
    params,
    method: 'GET',
  });
};
// 获取申报项目列表
export const getBudgetProjectReportList = async data => {
  return query('/zlb/budget/ep/project/report-list', {
    data,
    method: 'POST',
  });
};

// =============预算项目库==================================
// 分页查询项目申报列表
export const getProjectReportList = async params => {
  return query('/zlb/budget/project/report/list', {
    params,
    method: 'GET',
  });
};
// 经办人查询项目申报单详情
export const getBudgetProjectReportAgentDetail = async params => {
  return query('/zlb/budget/project/report/agent/detail', {
    params,
    method: 'GET',
  });
};
// 审批人查询项目申报单详情
export const getBudgetProjectReportAuditDetail = async params => {
  return query('/zlb/budget/project/report/audit/detail', {
    params,
    method: 'GET',
  });
};
// 保存更新项目申报单
export const saveBudgetProjectReport = async data => {
  return query('/zlb/budget/project/report/save-or-update', {
    data,
    method: 'POST',
  });
};
// 删除项目申报单
export const deleteBudgetProjectReport = async data => {
  return query('/zlb/budget/project/report/delete', {
    data,
    method: 'POST',
  });
};
// 清理项目申报单
export const cleanBudgetProjectReport = async data => {
  return query('/zlb/budget/project/report/clean', {
    data,
    method: 'POST',
  });
};
// 结转项目申报单
export const carryOverBudgetProjectReport = async data => {
  return query('/zlb/budget/project/report/carry-over', {
    data,
    method: 'POST',
  });
};
// 查询预算项目自动结转设置
export const carryOverBudgetProjectSettingsDetail = async () => {
  return query('/zlb/budget/ep/project/settings/project-carry-over/detail', {
    method: 'GET',
  });
};
// 保存预算项目自动结转设置
export const carryOverBudgetProjectSettings = async data => {
  return query('/zlb/budget/ep/project/settings/project-carry-over', {
    data,
    method: 'POST',
  });
};
// 项目结项
export const budgetProjectEndItem = async data => {
  return query('/zlb/budget/project/report/end-item', {
    data,
    method: 'POST',
  });
};
// 提交项目申报单
export const submitBudgetProjectReport = async data => {
  return query('/zlb/budget/project/report/workflow/submit', {
    data,
    method: 'POST',
  });
};
// 撤回项目申报单
export const cancelBudgetProjectReport = async data => {
  return query('/zlb/budget/project/report/workflow/cancel', {
    data,
    method: 'POST',
  });
};
// 批量结转项目申报单
export const batchCarryOverBudgetProjectReport = async data => {
  return query('/zlb/budget/project/report/batch-carry-over', {
    data,
    method: 'POST',
  });
};
// 项目申报选择项目明细
export const getProjectDetailList = async data => {
  return query('/zlb/api/mbp/baida/business/general-form/page-detail-list', {
    data,
    method: 'POST',
  });
};

// 部门明细变更否定
export const postPurchaseDetailUpdate = async data => {
  return query('/zlb/api/mbp/baida/business/general-form/purchase-detail-update', {
    data,
    method: 'POST',
  });
};

// ==============包干经费=====================
// 包干经费列表
export const getBudgetFundList = async params => {
  return query('/zlb/budget/fund/list', {
    params,
    method: 'GET',
  });
};

// 经费列表
export const getBudgetFundItemList = async data => {
  return query('/zlb/budget/fund/item-list', {
    data,
    method: 'POST',
  });
};

// 获取包干经费预算设置列表
export const getBudgetFundSettingList = async params => {
  return query('/zlb/budget/fund/setting-list', {
    params,
    method: 'GET',
  });
};

// 保存包干经费预算
export const saveBudgetFund = async data => {
  return query('/zlb/budget/fund/save-budget', {
    data,
    method: 'POST',
  });
};
// 保存包干经费费用信息
export const saveBudgetFundItem = data => {
  return query('/zlb/budget/fund/save-item', {
    data,
    method: 'POST',
  });
};
// 删除包干经费预算
export const deleteBudgetFund = async data => {
  return query('/zlb/budget/fund/delete', {
    data,
    method: 'POST',
  });
};
// 删除包干经费
export const deleteBudgetFundItem = async data => {
  return query('/zlb/budget/fund/delete-item', {
    data,
    method: 'POST',
  });
};

// 修改包干经费可用金额
export const updateBudgetFundAmount = async data => {
  return query('/zlb/budget/fund/update-fund-amount', {
    data,
    method: 'POST',
  });
};
// 拆分金额保存/修改
export const saveSplitFundAmount = async data => {
  return query('/zlb/budget/fund/split-amount-save', {
    data,
    method: 'POST',
  });
};
// 查询历史记录
export const getFundRecordList = async data => {
  return query('/zlb/budget/fund/record-list', {
    data,
    method: 'POST',
  });
};

// 修改已生效/废弃状态
export const updateBudgetFundStatus = async data => {
  return query('/zlb/budget/fund/update-status', {
    data,
    method: 'POST',
  });
};

// 导出经费获取code
export const getFundExportCode = async data => {
  return query('/zlb/budget/fund/export-fund', {
    data,
    method: 'POST',
  });
};

// 获取导出结果
export const getFundExportResult = async params => {
  return query('/zlb/budget/fund/export-result', {
    params,
  });
};

// 导出预算执行明细执行情况表
export const exportBudgetExecute = async data => {
  return query('/zlb/budget/ep/fill/record/export/budget-execute/submit', {
    data,
    method: 'POST',
  });
};

// 导出项目执行情况表
export const exportProjectExecute = async data => {
  return query('/zlb/budget/ep/fill/record/export/project-execute/submit', {
    data,
    method: 'POST',
  });
};

// ==============预算填报记录=================
// 日志查询
export const getBudgetRecordLog = async data => {
  return query('/zlb/budget/ep/fill/record/log/page', {
    data,
    method: 'POST',
  });
};

// 冻结
export const frozenBudgetRecord = async data => {
  return query('/zlb/budget/ep/fill/record/frozen', {
    data,
    method: 'POST',
  });
};

// 解冻
export const unFrozenBudgetRecord = async data => {
  return query('/zlb/budget/ep/fill/record/un-frozen', {
    data,
    method: 'POST',
  });
};

// 结转
export const transferBudgetRecord = async data => {
  return query('/zlb/budget/ep/fill/record/transfer', {
    data,
    method: 'POST',
  });
};

// 预算余额结转
export const batchTransferBudgetRecord = async data => {
  return query('/zlb/budget/ep/fill/record/batch-transfer', {
    data,
    method: 'POST',
  });
};

// 导入填报记录（预算填报页面）
export const importEpBudgetFillSubmit = async data => {
  return query('/zlb/budget/import/ep-budget-fill-record/submit', {
    method: 'POST',
    data,
  });
};

// 预算匹配
export const budgetMatchExecute = async data => {
  return query(`/zlb/budget/ep/fill/record/budget-match-execute/${data.year}`, {
    method: 'POST',
    data,
  });
};

// ==============预算调剂=====================
// 查询调整申请单列表
export const getBudgetAdjustList = async data => {
  return query('/zlb/budget/ep/adjustment-apply/page', {
    data,
    method: 'POST',
  });
};

// 查询调整申请单
export const getBudgetAdjustmentInfo = async params => {
  return query('/zlb/budget/ep/adjustment-apply/info', {
    params,
  });
};

// 删除调整申请单
export const deleteBudgetAdjustment = async params => {
  return query(`/zlb/budget/ep/adjustment-apply/delete/${params.orderNo}`, {
    method: 'POST',
  });
};

// 添加预算调整申请单
export const saveBudgetAdjustment = async data => {
  return query('/zlb/budget/ep/adjustment-apply/save', {
    method: 'POST',
    data,
  });
};

// ==============预算项目填报=====================
// 提交校验
export const recordSubmitCheck = async data => {
  return query('/zlb/budget/ep/fill/record/submit/check', {
    method: 'POST',
    data,
  });
};

// ==============实际采购情况=====================
// 项目实际明细列表
export const getPurchaseDetailList = async data => {
  return query('/zlb/budget/project/actual/purchase/detail/list', {
    method: 'POST',
    data,
  });
};
// 实际采购明细-需求单列表
export const getBudgetPurchaseDetailList = async data => {
  return query('/zlb/budget/project/actual-purchase/demand/page', {
    method: 'POST',
    data,
  });
};
// 实际采购明细-采购单详情
export const getBudgetPurchaseDetailInfo = async data => {
  return query('/zlb/budget/project/actual-purchase/demand/purchase/info', {
    method: 'POST',
    data,
  });
};
//
// 查询设备学科配置项
// 传TEACH_CENTER，或者 COURSE
export const getSubList = async data => {
  return query('/zlb/api/mbp/baida/business/general-form/purchase-base-info', {
    method: 'POST',
    data,
  });
};

// 导出项目明细查询列表taskid
export const exportPurchaseDetailList = async data => {
  return query('/zlb/api/mbp/baida/business/general-form/export/submit', {
    method: 'POST',
    data,
  });
};

// 导出项目明细查询列表
export const getExportPurchaseDetailListResult = async params => {
  return query('/zlb/api/mbp/baida/business/general-form/export/result', {
    method: 'GET',
    params,
  });
};
// 查看快照 {recordUk: xx}
export const getBudgetRecordSnapshotList = async data => {
  return query('/zlb/budget/ep/fill/record/snapshot/list', {
    method: 'POST',
    data,
  });
};
// 项目申报导出教学设备
export const exportPurchaseTeachingList = async data => {
  return query('/zlb/budget/project/report/export/teaching-equipment/submit', {
    method: 'POST',
    data,
  });
};
// 项目申报导出科研设备
export const exportPurchaseEquipmentList = async data => {
  return query('/zlb/budget/project/report/export/research-equipment/submit', {
    method: 'POST',
    data,
  });
};
// 导出项目明细查询列表
export const getExportBudgetListResult = async params => {
  return query('/zlb/budget/ep/fill/record/export/result', {
    method: 'GET',
    params,
  });
};

// ==============预算追加追减=====================
// 查询预算追加追减列表
export const getBudgetAddReductionList = async data => {
  return query('/zlb/budget/ep/additional-reduction-apply/page', {
    method: 'POST',
    data,
  });
};

// 保存预算追加追减申请单
export const saveBudgetAddReductionApply = async data => {
  return query('/zlb/budget/ep/additional-reduction-apply/save', {
    method: 'POST',
    data,
  });
};

// 查询预算追加追减申请单详情
export const getBudgetAddReductionInfo = async params => {
  return query('/zlb/budget/ep/additional-reduction-apply/info', {
    method: 'GET',
    params,
  });
};

// 删除预算追加追减申请单
export const deleteBudgetAddReductionApply = async params => {
  return query(`/zlb/budget/ep/additional-reduction-apply/delete/${params.orderNo}`, {
    method: 'POST',
  });
};

// 查询事项名称列表 （追加）
export const getItemList = async data => {
  return query('/zlb/budget/ep/additional-reduction-apply/item-list', {
    method: 'POST',
    data,
  });
};
// 查询事项名称列表 （追减和调剂）
export const getReductionItemList = async data => {
  return query('/zlb/budget/ep/project-use/item-list', {
    method: 'POST',
    data,
  });
};
// 查询费用项目列表(追加)
export const getCostList = async data => {
  return query('/zlb/budget/ep/additional-reduction-apply/cost-list', {
    method: 'POST',
    data,
  });
};
// 查询费用项目列表(追减和调剂)
export const getReductionCostList = async data => {
  return query('/zlb/budget/ep/project-use/cost-item-list', {
    method: 'POST',
    data,
  });
};
//  部门列表
export const getDepartmentList = async data => {
  return query('/zlb/budget/ep/project-use/department-list', {
    method: 'POST',
    data,
  });
};

// 项目列表
export const getProjectList = async data => {
  return query('/zlb/budget/ep/project-use/project-list', {
    method: 'POST',
    data,
  });
};

// 根据预算部门，项目列表查询科目列表
export const getSubjectTree = async data => {
  return query('/zlb/budget/ep/project-use/subject-tree', {
    method: 'POST',
    data,
  });
};
// 查询当前登录用户所属部门树（包含所有上级部门）
export const getCurrentOperatorDepHierarchy = async () => {
  return query('/zlb/budget/ep/dep/current/operator/hierarchy');
};
// 查询包干经费所属部门树
export const getCurrentOperatorFundDepList = async () => {
  return query('/zlb/budget/ep/dep/current/operator/fund/dep/list');
};

// ==============预算明细汇总=====================
// 预算明细查询列表
export const getBudgetDetailList = async data => {
  return query('/zlb/api/mbp/baida/business/general-form/purchase-budget-detail-list', {
    method: 'POST',
    data,
  });
};
// 导出预算明细列表
export const exportBudgetDetailList = async params => {
  return query('/zlb/api/mbp/baida/business/general-form/export/result', {
    method: 'GET',
    params,
  });
};

// ====================================单据预算查询===================================
// 预算明细查询列表
export const getFormBudgetList = async data => {
  return query('/zlb/budget/ep/correct/form-budget-detail/page', {
    method: 'POST',
    data,
  });
};

// 预算订正历史查询
export const getFormBudgetCorrectRecordList = async params => {
  return query('/zlb/budget/ep/correct/form-budget-correct-record/list', {
    params,
  });
};

// ====================================订正单据查询===================================
// 预算项目订正单据列表查询
export const getBudgetCorrectFormList = async data => {
  return query('/zlb/budget/ep/correct/budget-correct-form/page', {
    method: 'POST',
    data,
  });
};

// 预算项目订正申请单保存
export const saveBudgetCorrectForm = async data => {
  return query('/zlb/budget/ep/correct/budget-correct-form/save', {
    method: 'POST',
    data,
  });
};

// 预算项目订正申请单删除
export const deleteBudgetCorrectForm = async data => {
  return query(`/zlb/budget/ep/correct/budget-correct-form/delete/${data.orderNo}`, {
    method: 'POST',
    data,
  });
};

// 预算项目订正申请单详情
export const getBudgetCorrectFormDetail = async params => {
  return query('/zlb/budget/ep/correct/budget-correct-form/info', {
    params,
  });
};

// 检查预算项目订正申请单明细
export const checkCorrectForm = async data => {
  return query('/zlb/budget/ep/correct/budget-correct-form/detail/check', {
    method: 'POST',
    data,
  });
};

// ====================================费用项管理===================================
// 分页展示费用项列表
export const getCostItemList = async data => {
  return query('/zlb/budget/ep/cost-item/page', {
    method: 'POST',
    data,
  });
};

// 新增、编辑费用项
export const saveCostItem = async data => {
  return query('/zlb/budget/ep/cost-item/save', {
    method: 'POST',
    data,
  });
};

// 删除费用项
export const deleteCostItem = async data => {
  return query('/zlb/budget/ep/cost-item/delete', {
    method: 'POST',
    data,
  });
};

// 查看费用项详情
export const getCostItemDetail = async params => {
  return query('/zlb/budget/ep/cost-item/detail', {
    params,
  });
};

// 下拉枚举通用接口，项目类型选项: project_type、资金性质选项: funds_nature、项目属性选项: project_attribute
export const getCommonOption = async data => {
  return query('/zlb/budget/ep/common/option', {
    method: 'POST',
    data,
  });
};

// ====================================项目管理===================================
// 经办人查询列表
export const getAgentProjectList = async data => {
  return query('/zlb/budget/ep/project-management/agent/page', {
    method: 'POST',
    data,
  });
};

// 获取历史记录列表
export const getProjectHistoryRecordList = async data => {
  return query('/zlb/api/mbp/baida/business/general-form-snapshot/list-snapshot', {
    method: 'POST',
    data,
  });
};

// 财务查看列表
export const getFinanceProjectList = async data => {
  return query('/zlb/budget/ep/project-management/finance/page', {
    method: 'POST',
    data,
  });
};

// 项目来源查询
export const getProjectSourceList = async data => {
  return query('/zlb/budget/ep/project-management/external/project-source-list', {
    method: 'POST',
    data,
  });
};

// 项目拆分
export const projectSplitInit = async data => {
  return query('/zlb/budget/ep/project-management/internal/split', {
    method: 'POST',
    data,
  });
};

// 项目合并
export const projectMergeInit = async data => {
  return query('/zlb/budget/ep/project-management/internal/merge', {
    method: 'POST',
    data,
  });
};

// 预算项目下发
export const pushInternalProject = async data => {
  return query('/zlb/budget/ep/project-management/internal/push', {
    method: 'POST',
    data,
  });
};

// 内部项目-批量转为外部项目
export const interBatchTransforExternal = async data => {
  return query('/zlb/budget/ep/project-management/internal/batch-to-external', {
    method: 'POST',
    data,
  });
};

// 删除外部项目
export const deleteExternalProject = async data => {
  return query('/zlb/budget/ep/project-management/external/delete', {
    method: 'POST',
    data,
  });
};

// 查询单位资金来源配置
export const getFundsSourceConfigList = async () => {
  return query('/zlb/budget/ep/project-management/internal/project-funds-source-config', {});
};

// 编辑单位资金来源配置
export const editFundsSourceConfig = async data => {
  return query('/zlb/budget/ep/project-management/internal/project-funds-source-config/edit', {
    method: 'POST',
    data,
  });
};

// 内部项目-项目资金来源分配详情
export const getProjectFundsSourceDetail = async params => {
  return query('/zlb/budget/ep/project-management/internal/project-funds-source-detail', {
    params,
  });
};

// 内部项目-项目资金来源分配
export const saveProjectFundsSource = async data => {
  return query('/zlb/budget/ep/project-management/internal/project-funds-source-save', {
    method: 'POST',
    data,
  });
};

// 内部项目-项目资金性质详情
export const getProjectFundsNatureDetail = async params => {
  return query('/zlb/budget/ep/project-management/internal/project-funds-nature-detail', {
    params,
  });
};

// 内部项目-项目资金性质保存
export const saveProjectFundsNature = async data => {
  return query('/zlb/budget/ep/project-management/internal/project-funds-nature-save', {
    method: 'POST',
    data,
  });
};

// ====================================财政预算项目===================================
// 预算项目列表
export const getGovBudgetProjectList = async data => {
  return query('/zlb/budget/ep/project-v2/page', {
    method: 'POST',
    data,
  });
};

// ====================================绩效指标===================================
// 绩效指标列表
export const getPerformIndicatorList = async data => {
  return query('/zlb/budget/ep/perf-indicator/page', {
    method: 'POST',
    data,
  });
};

// 新增/编辑绩效指标
export const savePerformIndicator = async data => {
  return query('/zlb/budget/ep/perf-indicator/save', {
    method: 'POST',
    data,
  });
};

// 绩效指标详情
export const getPerformIndicatorDetail = async params => {
  return query('/zlb/budget/ep/perf-indicator/detail', {
    params,
  });
};

// 删除绩效指标
export const deletePerformIndicator = async data => {
  return query('/zlb/budget/ep/perf-indicator/delete', {
    method: 'POST',
    data,
  });
};

// ====================================项目科目汇总===================================
// 项目科目汇总列表
export const getSubjectSummaryList = async data => {
  return query('/zlb/budget/ep/project-management/subject-summary/page', {
    method: 'POST',
    data,
  });
};

// 汇总导出提交，生成code
export const getSubjectSummaryExportCode = async data => {
  return query('/zlb/budget/ep/project-management/subject-summary/export/submit', {
    method: 'POST',
    data,
  });
};

// 获取导出结果
export const getSubjectSummaryExportResult = async params => {
  return query('/zlb/budget/export/result', {
    params,
  });
};
// ====================================项目储备管理===================================
export const getBudgetEpProjectPoolManageList = async data => {
  return query('/zlb/budget/ep/project-pool/manage/page', {
    method: 'POST',
    data,
  });
};
// ====================================项目储备审核===================================
export const getBudgetEpProjectPoolAuditList = async data => {
  return query('/zlb/budget/ep/project-pool/audit/page', {
    method: 'POST',
    data,
  });
};

// 批量导入预算编制库
export const batchImportBudgetCompileLib = async data => {
  return query('/zlb/api/mbp/baida/business/general-form/batch-copy', {
    method: 'POST',
    data,
  });
};

// ====================================事项管理===================================
// 分页展示事项列表
export const getMatterItemList = async data => {
  return query('/zlb/budget/ep/item/page', {
    method: 'POST',
    data,
  });
};

// 查看事项详情
export const getMatterItemDetail = async params => {
  return query('/zlb/budget/ep/item/detail', {
    params,
  });
};

// 新增、编辑事项
export const saveMatterItem = async data => {
  return query('/zlb/budget/ep/item/save', {
    method: 'POST',
    data,
  });
};

// 删除事项
export const deleteMatterItem = async params => {
  return query('/zlb/budget/ep/item/delete', {
    method: 'get',
    params,
  });
};
